import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_OPACITY,
  ASSETS_PRIMARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,
    and: FONT_FAMILY.and,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '32px',
    body: '19px',
    body_lv2: '17px',
    and: '66px',
  },
  fontWeights: {
    heading: 400,
    body: 500,
    body_lv2: 500,
    and: 300,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-and': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(249,245,236,1)',
    bgSecondary: 'rgba(212,160,139,1)',
    mainAssetColor: 'rgba(229,208,179,1)',
    bgAlternative: '#FFFFFF',
    bgOpacity: 'rgba(22,17,13,1)',
    mainColorText: 'rgba(22,17,13,1)',
    secondaryColorText: 'rgba(164,115,46,1)',
    alternativeColorText: '#FEFEFE',

    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'subHeading',
      },
    },
  },
};

export default extendTheme(theme);
